import { render } from "./varriant-attributes-modal.vue?vue&type=template&id=8a2b063e"
import script from "./varriant-attributes-modal.vue?vue&type=script&lang=js"
export * from "./varriant-attributes-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__